import format from "date-fns/format";
import useApiRequest from "../../../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../../models/BasketItem";
import useFacility from "../../../../../../utils/hooks/useFacility";
import { BasketItem } from "../../../../../models/BasketItem";
import useBasketManager from "../useBasketManager";
import { useState } from "react";

export default function useSrem() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const { getBasket } = useBasketManager();
  const [rockets, setRocket] = useState<number>(0);
  const [tickets, setTickets] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const addGuideToBasket = async (ids: number, qnt: number) => {
    setLoading(true);
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const { isError } = await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
    setLoading(false);
  };

  const addRocket = async (basketList: BasketItem[]) => {
    let bilety: number = 0;
    let rockets: number = 0;
    basketList.map((item: BasketItem) => {
      if (
        item.assortIds === "0,405" ||
        item.assortIds === "0,273" ||
        item.assortIds === "0,406"

      ) {
        bilety = bilety + item.qnt;
      }
      if (item.assortIds === "0,+407") {
        rockets = rockets + item.qnt;
 
      }
    });

    setTimeout(() => {


      if(bilety !== rockets){
        addGuideToBasket(407, bilety - rockets)
      }


    }, 100);

  };

  return {
    addRocket,
    loading
  };
}
